<template>
  <div class="bc-report-baseinfo">
    <type-container title="基本信息">
      <business-table :company-id="companyId" />
      <pagination-table
        v-for="table in typeTables"
        :key="table.key"
        :title="table.source.title"
        :table-data="table.source.entities"
        :table-props="table.source.props"
        :total="table.source.total"
        :loading="table.source.loading"
        :page-index="table.source.pageIndex"
        :page-size="table.source.pageSize"
        :show-total="table.source.showTotal"
        :show-header="table.source.showHeader"
        @pageChanged="tablePageChanged($event, table)"
      />
    </type-container>
  </div>
</template>

<script>
import PaginationTable from '@/components/table/PaginationTable'
import TypeContainer from '@/components/report/ReportTypeContainer'
import lawExamService from '@/service/law-exam'
import BusinessTable from '@/components/table/BusinessTable'
import mixin from '@/mixins/lawExamReport.js'
import lawExamProps from '@/service/law-exam/props'

export default {
  name: 'BcReportBaseinf',
  components: { PaginationTable, TypeContainer, BusinessTable },
  mixins: [ mixin ],
  data () {
    return {
      changeRecord: { ...lawExamProps.changeRecord },
      executive: { ...lawExamProps.executive },
      investment: { ...lawExamProps.investment },
      shareholder: { ...lawExamProps.shareholder }
    }
  },
  computed: {
    // 基本信息 companyBaseInfo
    // 工商信息 businessInformation
    // 高管信息 executive
    // 股东信息 shareholder
    // 投资信息 investment
    // 工商变更 changeRecord
    typeTables () {
      return [
        { key: 'executive', source: this.executive },
        { key: 'shareholder', source: this.shareholder },
        { key: 'investment', source: this.investment },
        { key: 'changeRecord', source: this.changeRecord }
      ]
    }
  },
  methods: {
    requestInfo (page, table) {
      let source = table.source
      let path = table.key
      source.loading = true
      let params = { companyId: this.companyId, pageNum: page, pageSize: source.pageSize }
      lawExamService.reportRequestBaseInfo(path, params).then(res => {
        this.parseData(path, res, source, page)
      }).catch(_ => {
        source.loading = false
      })
    }
  }
}
</script>

<style lang="stylus">
.bc-report-baseinf
  background-color red
</style>
